import React, { createContext, useContext, useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import { BrazilDate } from "../../../utils/BrazilDate";
import { useLojas } from "../../../hooks/useLojas";

type SelectedLojaId = number | "all";

interface InspecaoContextValue {
  user: ReturnType<typeof useAuth>["user"];
  dataInicio: string;
  setDataInicio: (value: string) => void;
  dataFim: string;
  setDataFim: (value: string) => void;
  selectedLojaId: SelectedLojaId;
  setSelectedLojaId: (value: SelectedLojaId) => void;
  lojas: any[];
  pedidoDisplayIdInput: string;
  setPedidoDisplayIdInput: (value: string) => void;
  appliedPedidoDisplayId: number | null;
  setAppliedPedidoDisplayId: (value: number | null) => void;
}

const InspecaoContext = createContext<InspecaoContextValue | undefined>(
  undefined
);

export const InspecaoProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { user } = useAuth();
  const defaultDate = BrazilDate.todayISO();

  const [dataInicio, setDataInicioState] = useState(defaultDate);
  const [dataFim, setDataFimState] = useState(defaultDate);

  const setDataInicio = (value: string) => {
    setDataInicioState(value);
    setDataFimState((f) => (f < value ? value : f));
  };

  const setDataFim = (value: string) => {
    setDataFimState(value);
    setDataInicioState((s) => (value < s ? value : s));
  };
  const [selectedLojaId, setSelectedLojaId] = useState<SelectedLojaId>(
    user?.lojaId ?? "all"
  );
  const [pedidoDisplayIdInput, setPedidoDisplayIdInput] = useState("");
  const [appliedPedidoDisplayId, setAppliedPedidoDisplayId] = useState<
    number | null
  >(null);

  const { data: lojasResponse } = useLojas();
  const lojas = lojasResponse ?? [];

  return (
    <InspecaoContext.Provider
      value={{
        user,
        dataInicio,
        setDataInicio,
        dataFim,
        setDataFim,
        selectedLojaId,
        setSelectedLojaId,
        lojas,
        pedidoDisplayIdInput,
        setPedidoDisplayIdInput,
        appliedPedidoDisplayId,
        setAppliedPedidoDisplayId,
      }}
    >
      {children}
    </InspecaoContext.Provider>
  );
};

export const useInspecaoContext = (): InspecaoContextValue => {
  const context = useContext(InspecaoContext);
  if (!context) {
    throw new Error(
      "useInspecaoContext deve ser usado dentro de InspecaoProvider"
    );
  }
  return context;
};
